import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Component_SearchAddOn } from '../../components/Component_SearchAddOn.js';
import { AddOn_EntityFilter } from './types.js';
import { LL_H_C, SimpleListAdapter, TS_Checkbox, TS_DropDown, TS_PropRenderer } from '@nu-art/thunderstorm-frontend';
import { TS_Icons } from '@nu-art/ts-styles';
import './Component_AddOn_EntityFilter.scss';
export class Component_AddOn_EntityFilter extends Component_SearchAddOn {
    addOn = AddOn_EntityFilter;
    // ######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.label = nextProps.label ?? 'By Entity';
        state.activeSearchItems = nextProps.context.getActiveSearchItems();
        state.permanentOnScreenEntityKeys = nextProps.permanentOnScreenEntityKeys ?? [];
        return state;
    }
    // ######################### Logic #########################
    onItemSelected = (searchItem) => {
        const items = this.state.value ? [...this.state.value] : [];
        items.push(searchItem.module.dbDef.dbKey);
        this.setValue(items);
    };
    onItemRemoved = (searchItem) => {
        const items = (this.state.value ?? []).filter(item => item !== searchItem.module.dbDef.dbKey);
        this.setValue(items);
    };
    // ######################### Render #########################
    render() {
        if (!this.state.activeSearchItems)
            return;
        const keys = this.state.value?.filter(key => !this.state.permanentOnScreenEntityKeys.includes(key));
        return _jsx(TS_PropRenderer.Vertical, { label: this.render_Label, className: 'search-add-on__entity-filter', children: _jsxs(LL_H_C, { className: 'search-add-on__entity-filter__item-list', children: [this.render_PermanentOnScreenItems(), keys?.map(this.render_SelectedItem), this.render_ItemSelector()] }) });
    }
    render_Label = () => {
        return _jsxs(_Fragment, { children: [this.state.label, _jsx(TS_Icons.clear.component, { onClick: this.clear })] });
    };
    render_PermanentOnScreenItems = () => {
        if (!this.state.permanentOnScreenEntityKeys.length)
            return;
        return _jsx(_Fragment, { children: this.state.permanentOnScreenEntityKeys.map(this.render_SelectedItem) });
    };
    render_SelectedItem = (itemKey) => {
        const searchItem = this.state.activeSearchItems.find(item => item.module.dbDef.dbKey === itemKey);
        if (!searchItem)
            return;
        const selected = this.state.value?.includes(itemKey);
        return _jsxs(LL_H_C, { className: 'search-add-on__entity-filter__selected-item', children: [_jsx(TS_Checkbox, { checked: selected, onCheck: () => {
                        if (selected)
                            return this.onItemRemoved(searchItem);
                        this.onItemSelected(searchItem);
                    } }), searchItem.entityLabel] }, searchItem.module.dbDef.dbKey);
    };
    render_ItemSelector = () => {
        const adapter = SimpleListAdapter(this.state.activeSearchItems, item => _jsx(_Fragment, { children: item.item.entityLabel }));
        return _jsx(TS_DropDown, { adapter: adapter, selected: undefined, onSelected: this.onItemSelected, placeholder: 'Select an entity', queryFilter: item => !this.state.value?.includes(item.module.dbDef.dbKey) && !this.state.permanentOnScreenEntityKeys.includes(item.module.dbDef.dbKey) });
    };
}
//# sourceMappingURL=Component_AddOn_EntityFilter.js.map